import React from "react";
import { ShareButton } from "../../../MVVM/Components/Button/Share";
import { HiLink } from "react-icons/hi";
import styled from "styled-components";
import { Tooltip } from "../../atoms/tooltip";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";
import { Box } from "rebass";

export default function CopyLink({
  classification,
  clipLink,
  clip,
  card,
  children,
  size,
  hideOnMobile,
  mr,
  isMontage,
}) {
  const EncodedURI = encodeURI(clipLink);
  classification = classification ? classification : "secondary";

  return (
    <>
      <Tooltip
        position={{
          top: "-42px",
          padding: "10px",
          right: "-30px",
        }}
        type="click"
        timeout={true}
        theme="helpTooltip"
        align="right"
        tooltipContent={
          <Box name="url-copied-tooltip">URL copied to clipboard!</Box>
        }
      >
        <StyledShareButton
          hideOnMobile={hideOnMobile}
          title="Copy Link"
          name="clip-options-copy-link"
          flex={true}
          width="100%"
          mr={mr}
          size={size}
          justifyContent="space-between"
          classification={classification}
          alignItems="center"
          onClick={() => {
            if (clip) {
              trackClipSocialShare({
                platform: "Clipboard",
                isMontage: isMontage,
                clip,
              });
            } else if (card) {
              trackCreatorCardShare({ ...card });
            }

            if (window.Gleam) {
              window.Gleam.push("shareClip");
            }
            navigator.clipboard.writeText(EncodedURI);
          }}
        >
          <StyledShare size={20} />
          {children}
        </StyledShareButton>
      </Tooltip>
    </>
  );
}

const StyledShare = styled(HiLink)`
  position: relative;
  top: 4px;
`;

const StyledShareButton = styled(ShareButton)`
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    ${(props) => (props.hideOnMobile ? "display:none" : null)};
  }
`;
